
import { i18nText } from '@/locales';
import Vue from "vue";
import Component from "vue-class-component";
import { ITableColumn } from "@/entity/table/table.types";
@Component
export class OperationsTableMix extends Vue {
    get columns(): ITableColumn[] {
        return [
            {
                title: "",
                dataIndex: "actions",
                scopedSlots: {
                    customRender: "operation"
                },
            },
            {
                title: i18nText("Дата"),
                dataIndex: "date",
                key: "date",
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                    customRender: "DateColumn"
                },
            },
            {
                title: i18nText("Операция"),
                dataIndex: "type_name",
                key: "type_name",
                scopedSlots: { 
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                    customRender: "OperationType"
                },
            },
            {
                title: i18nText("Склад"),
                dataIndex: "store_name",
                key: "store_name",
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
            {
                title: i18nText("Товар"),
                dataIndex: "products",
                key: "products",
                scopedSlots: {
                    //filterDropdown: "filterDropdown",
                    //filterIcon: "filterIcon",
                    customRender: "ProductColumn"
                },
            },
            {
                title: i18nText("Кол-во"),
                dataIndex: "quantity",
                key: "quantity",
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                    //customRender: "quantityColumn"
                },
            },
            {
                title: i18nText("Стоимость"),
                dataIndex: "total_sum",
                key: "total_sum",
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                    //customRender: "total_sum"
                },
            },
            {
                title: i18nText("Остаток"),
                dataIndex: "stock_balance",
                key: "stock_balance",
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                   //customRender: "OriginColumn"
                },
            },
            {
                title: i18nText("Визит"),
                dataIndex: "visit_dt",
                key: "visit_dt",
                sortField: 'visit_dt',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                    customRender: "VisitsColumn"
                },
            },
        ];
    }
}
